import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=5f36251f&scoped=true"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=5f36251f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f36251f",
  null
  
)

export default component.exports